import { useMemo, useRef } from 'react';
import { useLayoutEffect } from './useLayoutEffect';

// declare function useCallbackRef<T: (...args: $ReadOnlyArray<empty>) => mixed>(
//   callback: T | void
// ): T;
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders
 * when passed as a prop or avoid re-executing effects when passed as a dependency.
 * @see https://github.com/facebook/react/issues/14099
 * @see https://github.com/facebook/react/issues/19240
 * Will probably supplement ./useEventCallback.
 */
export function useCallbackRef(callback) {
  var callbackRef = useRef(callback);
  useLayoutEffect(function () {
    callbackRef.current = callback;
  });
  return useMemo(function () {
    return function () {
      var _callbackRef$current;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call.apply(_callbackRef$current, [callbackRef].concat(args));
    };
  }, []);
}